import {z} from 'zod';

export const DashboardFormSchema = z.object({
  salesFunnelBusinessCases: z.boolean(),
  salesFunnelInterests: z.boolean(),
  hasSalesFunnel: z.boolean(),
  vehicleStock: z.boolean(),
  latestVehicles: z.boolean(),
  latestBusinessCases: z.boolean(),
  latestInterests: z.boolean(),
  notifications: z.boolean(),
  myTasks: z.boolean(),
});

export type DashboardFormSchemaType = z.infer<typeof DashboardFormSchema>;
